import styled from 'styled-components'

import { DetailsListItem } from 'components/DetailsListItem'

export const StyledDetailsListItem = styled(DetailsListItem)`
  padding-bottom: 0;
`
